import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { finalize } from 'rxjs/operators';
import { TeamService } from '../../_core/services/team.service';
import { Team } from '../../_shared/models/team.model';
import { TeamHelperService } from '../team-helper.service';

@Component({
  standalone: false,
  selector: 'app-team-selector',
  templateUrl: './team-selector.component.html',
  styleUrls: ['./team-selector.component.scss'],
})
export class TeamSelectorComponent implements OnInit {
  teams: Team[] = [];
  isLoading: boolean;

  selectedTeams: string[] = [];

  constructor(
    private teamService: TeamService,
    private modalController: ModalController,
    public ths: TeamHelperService
  ) {}

  ngOnInit() {
    this.getMyTeams();
  }

  private getMyTeams() {
    this.isLoading = true;
    this.teamService
      .getMyTeams()
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe((res) => {
        this.teams = res.data;
      });
  }

  selectTeam(ev, index) {
    if (ev.detail.checked) {
      this.selectedTeams.push(this.teams[index]._id);
    } else {
      const tieIndex = this.selectedTeams.findIndex(
        (teamId) => teamId === this.teams[index]._id
      );
      this.selectedTeams.splice(tieIndex, 1);
    }
  }

  selectTeams() {
    this.modalController
      .getTop()
      .then((modal) => modal.dismiss(this.selectedTeams));
  }

  close() {
    this.modalController.getTop().then((modal) => modal.dismiss());
  }
}
